import { render, staticRenderFns } from "./tab-bar.vue?vue&type=template&id=369f1d7c"
import script from "./tab-bar.vue?vue&type=script&lang=js"
export * from "./tab-bar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports